import { render, staticRenderFns } from "./ReferralsList.vue?vue&type=template&id=03011f77&scoped=true"
import script from "./ReferralsList.vue?vue&type=script&lang=js"
export * from "./ReferralsList.vue?vue&type=script&lang=js"
import style0 from "./ReferralsList.vue?vue&type=style&index=0&id=03011f77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03011f77",
  null
  
)

export default component.exports